import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import type { CreationContextParams } from '@atlassian/conversation-assistant-external-context/types';

type RemixResponseAttributes = {
	remixExperience?: CreationContextParams['experience'];
};

/** Attributes the response to its originating request, regardless of the returned action. */
export const getRemixResponseAttributes = (
	creationContextParams?: CreationContextParams,
): RemixResponseAttributes => {
	if (
		!isExperimentEnabled('cc_maui_custom_edit_analytics') ||
		creationContextParams?.source !== 'remix' ||
		!creationContextParams.experience
	) {
		return {};
	}

	return {
		remixExperience: creationContextParams.experience,
	};
};
